import Onboarding from "./components/Onboarding";

const index = () => {
  return <Onboarding />;
};

export default index;
